import { Fit, Layout, Rive } from '@rive-app/canvas'
import { onCleanup, onMount } from 'solid-js'
import { Motion } from 'solid-motionone'
import { loadingRewardRive } from '~/assets/anim/rive-files'
import { rewardFlow, type PreviewAnimState } from '../store'

type Props = {
  state: PreviewAnimState
}

export function PreviewAnim(props: Props) {
  let canvas!: HTMLCanvasElement // oxlint-disable-line eslint/no-unassigned-vars
  let rive: Rive | null = null

  const handleResize = () => rive?.resizeDrawingSurfaceToCanvas()

  onMount(() => {
    let disposed = false
    loadingRewardRive.then((riveFile) => {
      if (disposed) return
      rive = new Rive({
        riveFile,
        canvas,
        autoplay: true,
        artboard: 'chestbox_open',
        stateMachines: ['State Machine 1'],
        layout: new Layout({ fit: Fit.FitHeight }),
        onLoad: () => {
          rive!.resizeDrawingSurfaceToCanvas()
          window.addEventListener('resize', handleResize)
          const inputs = rive!.stateMachineInputs('State Machine 1')
          for (const input of inputs) {
            if (input.name === 'chestbox') input.value = props.state.chapter
          }
        },
        onStateChange: ({ data }) => {
          if (Array.isArray(data) && data[0] === 'exit') {
            rewardFlow.endPreviewAnim()
          }
        },
      })
    })

    onCleanup(() => {
      disposed = true
      window.removeEventListener('resize', handleResize)
      rive?.cleanup()
      rive = null
    })
  })

  return (
    <Motion.div
      class="mb-auto mt-auto h-[40vh] w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <canvas ref={canvas} class="h-full w-full" />
    </Motion.div>
  )
}
